export const isProject = <T extends { __typename: 'Project' | 'Share' }>(
  item: T
  // eslint-disable-next-line @typescript-eslint/ban-types
): item is Extract<T, { __typename: 'Project' }> => {
  return item.__typename === 'Project'
}

export const isShare = <T extends { __typename: 'Project' | 'Share' }>(
  item: T
  // eslint-disable-next-line @typescript-eslint/ban-types
): item is Extract<T, { __typename: 'Share' }> => {
  return item.__typename === 'Share'
}
